import { useCallback } from 'react';

import { MagistralDrugTemplate, MagistralDrugTemplateUpdateCommand } from '@dreryk/drerykweb-medicine-api';

import { PromiseVoidFunction } from '@dreryk/react-common';
import { Choice } from '@dreryk/watermelon';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import {
   MagistralDrugTemplateFormBean,
   MagistralDrugTemplateFormController,
} from './form/MagistralDrugTemplateForm.types';
import { mapMedicineRawMaterialsTableBeanToMagistralDrugRawMaterials } from './modal/MagistralDrugTemplatesCommand.utils';

type MagistralDrugTemplatesUpdateTemplateButtonProps = {
   readonly handleSubmit: MagistralDrugTemplateFormController['handleSubmit'];
   readonly onSuccess: PromiseVoidFunction;
   readonly disabled: boolean;
};

export const MagistralDrugTemplatesUpdateTemplateButton = (
   props: MagistralDrugTemplatesUpdateTemplateButtonProps
): JSX.Element => {
   const commandCreator = useCallback((variables: MagistralDrugTemplateFormBean, templateId: number) => {
      const command = new MagistralDrugTemplateUpdateCommand();
      command.id = templateId;
      command.name = Choice.of(variables.drugName);
      command.additionalDetails = Choice.withUseDefaultIfNull(variables.additionalDetails ?? null);
      command.form = Choice.withUseDefaultIfNull(variables.drugForm ?? null);
      command.magistralDrugMedicineRawMaterials = mapMedicineRawMaterialsTableBeanToMagistralDrugRawMaterials(
         variables.medicineRawMaterials
      );
      return command;
   }, []);
   return (
      <FormsTemplates.SendTemplateButton<MagistralDrugTemplateFormBean, MagistralDrugTemplate>
         disabled={props.disabled}
         handleSubmit={props.handleSubmit}
         commandCreator={(variables, id) => commandCreator(variables, id as number)}
         onSuccess={props.onSuccess}
      />
   );
};
